"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.ViewType = void 0;
var ViewType;
(function (ViewType) {
    ViewType[ViewType["mobile"] = 0] = "mobile";
    ViewType[ViewType["desktop"] = 1] = "desktop";
})(ViewType = exports.ViewType || (exports.ViewType = {}));
var init = function () {
    var activeClass = 'tedee-tabs__tab--active';
    var inactiveBtn = "a:not(.".concat(activeClass, ")");
    var $tabs = $('.tedee-tabs--lang-select');
    var fadeSpeed = 200;
    var currentView;
    //init
    enableEvents();
    checkWidth();
    function enableEvents() {
        $tabs.find('a').on('click', function () { return toggleInactiveButtons(); });
        $(window).on('resize', function () { return checkWidth(); });
    }
    function checkWidth() {
        var newView = checkViewBreakPoint();
        if (newView !== currentView) {
            var inactiveLinks = $tabs.find(inactiveBtn);
            currentView = newView;
            currentView === ViewType.desktop ?
                inactiveLinks.fadeIn(fadeSpeed) : inactiveLinks.fadeOut(fadeSpeed);
        }
    }
    function toggleInactiveButtons() {
        if (currentView === ViewType.mobile) {
            $tabs.find(inactiveBtn).slideToggle(fadeSpeed);
        }
    }
    function checkViewBreakPoint() {
        return $(window).width() <= 768 ? ViewType.mobile : ViewType.desktop;
    }
};
exports.init = init;
